<h2 mat-dialog-title>Agregar categoría</h2>

<mat-dialog-content>
  <p class="intro">
    Una categoría define qué botones ve el vecino y en qué pantalla. Podés usar
    una que ya existe, duplicarla para tocarla sin afectar a nadie, o arrancar
    de cero.
  </p>

  <div class="filtros">
    <mat-form-field appearance="outline" class="buscador">
      <mat-label>Buscar categoría</mat-label>
      <input
        matInput
        [(ngModel)]="busqueda"
        [ngModelOptions]="{ standalone: true }"
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <mat-checkbox
      [(ngModel)]="soloDisponibles"
      [ngModelOptions]="{ standalone: true }"
    >
      Ocultar las que ya tiene el cliente
    </mat-checkbox>
  </div>

  <div class="lista">
    @for (fila of filasFiltradas; track fila.categoria._id) {
      <div class="fila" [class.ya-usada]="fila.yaUsada">
        <div class="fila-datos">
          <strong>{{ fila.etiqueta }}</strong>
          <div class="meta">
            <span class="pill">{{ fila.botonera }}</span>
            <span>{{ fila.cantidadBotones }} botón(es)</span>
            @if (fila.clientes.length) {
              <span
                class="pill compartida"
                [matTooltip]="fila.clientes.join(', ')"
              >
                compartida · {{ fila.clientes.length }} cliente(s)
              </span>
            } @else {
              <span class="pill libre">sin usar</span>
            }
            @if (fila.yaUsada) {
              <span class="pill ya">ya está en este cliente</span>
            }
          </div>
        </div>
        <div class="fila-acciones">
          <button
            mat-stroked-button
            type="button"
            [disabled]="fila.yaUsada"
            [matTooltip]="
              fila.clientes.length
                ? 'Queda compartida: lo que edites lo ven esos clientes'
                : 'Usar esta categoría tal cual'
            "
            (click)="usar(fila)"
          >
            Usar
          </button>
          <button
            mat-flat-button
            color="primary"
            type="button"
            matTooltip="Crea una copia propia de este cliente (los botones se referencian, no se duplican)"
            (click)="duplicar(fila)"
          >
            <mat-icon>content_copy</mat-icon> Duplicar
          </button>
        </div>
      </div>
    } @empty {
      <p class="vacio">No hay categorías que coincidan.</p>
    }
  </div>

  <div class="desde-cero">
    <span class="titulo">O arrancar de cero</span>
    <div class="presets">
      <button mat-stroked-button type="button" (click)="enBlanco('basica')">
        <mat-icon>crop_square</mat-icon>
        Básica · 1 pantalla
      </button>
      <button mat-stroked-button type="button" (click)="enBlanco('completa')">
        <mat-icon>grid_view</mat-icon>
        Completa · 3 pantallas
      </button>
    </div>
    <span class="nota">
      La categoría se crea recién al guardar el cliente.
    </span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cerrar()">Cancelar</button>
</mat-dialog-actions>
